// Reglas puras del step api_call, alineadas con api_call_step_executor.py y
// ApiCallStepParameters del backend. Sin React para poder testearlas aislado.

export const DEFAULT_API_CALL_TIMEOUT = 30;

// Misma regla que el backend: urljoin(base.rstrip("/") + "/", url.lstrip("/")),
// y una URL absoluta ignora el base_url (startswith en Python: sensible a mayúsculas).
export const resolveApiCallUrl = (baseUrl, url, queryParams = null) => {
  const path = url || "";
  const full = !baseUrl || /^https?:\/\//.test(path)
    ? path
    : `${baseUrl.replace(/\/+$/, "")}/${path.replace(/^\/+/, "")}`;
  const query = Object.entries(queryParams || {})
    .map(([k, v]) => `${k}=${v ?? ""}`)
    .join("&");
  if (!query) return full;
  return `${full}${full.includes("?") ? "&" : "?"}${query}`;
};

// El body se guarda como objeto si es JSON válido y como texto si no (p. ej.
// mientras se escribe). Mostrar el texto tal cual evita re-envolverlo en comillas.
export const formatApiCallBody = (body) => {
  if (body === undefined || body === null || body === "") return "";
  return typeof body === "string" ? body : JSON.stringify(body, null, 2);
};

// El backend acepta body como dict o string: un JSON que no sea objeto (array,
// número, null) se guarda como texto para no fallar la validación.
export const parseApiCallBody = (text) => {
  try {
    const value = JSON.parse(text);
    return value && typeof value === "object" && !Array.isArray(value) ? value : text;
  } catch {
    return text;
  }
};

// timeout es int > 0 en el backend. Devuelve null si el texto no es válido
// (vacío mientras se escribe): quien llama decide no guardarlo.
export const parseApiCallTimeout = (text) => {
  const n = parseInt(text, 10);
  return Number.isFinite(n) && n > 0 ? n : null;
};
